import { useUserState } from '../../auth/UserState';
import { useWorkspaces } from '../../auth/WorkspaceState';
import { NavigationItem } from './NavigationItem';
import { useSideNavigation } from './SideNavigationContext';

export function UserMenu() {
  const { user } = useUserState();
  const { current: workspace, workspaces } = useWorkspaces();
  const { isCollapsed } = useSideNavigation();

  const primaryText =
    workspaces.length === 1 ? workspace?.workspaceName : user?.displayName || 'Account';

  const secondaryText = workspaces.length === 1 ? user?.displayName : user?.email;

  return (
    <NavigationItem to="/account" icon="user">
      {!isCollapsed ? (
        <div className="min-w-0">
          <div className="truncate text-sm font-medium">{primaryText}</div>
          <div className="truncate text-xs opacity-70">{secondaryText}</div>
        </div>
      ) : (
        user?.displayName || 'Account'
      )}
    </NavigationItem>
  );
}
